<template>
<div class='subtitle-div'>
  <p class='subtitle-text'>
    <slot></slot>
  </p>
  <hr>
</div>
</template>


<script>
export default {
  props: {
    text: String
  }
}
</script>


<style lang='scss' scoped>
.subtitle-div {
  padding-top: 2rem;
  padding-bottom: .5rem;
}

.subtitle-text {
  font-family: Rubik, sans-serif;
  font-weight: 700;
  font-size: 2rem;

  color: white;

}

hr {
  background-color: $purple;
  
  //width of the bar
  height: 4px;
  padding-bottom: 2px;

  margin: 0;
}
</style>
